import Extension from "../base/extension";

class RelatedProductsSwiper extends Extension {
  constructor(name) {
    super(name);
  }
  init() {
    document.addEventListener("minicart:rendered", () => {
      console.log(this.logPrefix, "Minicart rendered");
      this.initaliseRelatedProductSwiper()
    });

  }

  initaliseRelatedProductSwiper() {
    const swiperEl = document.querySelector('#swiper-related-products .swiper');

    // The carousel is only rendered on product pages whose product has
    // related products and when the cart isn't empty (see
    // cart-offcanvas-content.liquid), so most minicart renders won't have it.
    if (!swiperEl || !(swiperEl instanceof HTMLElement)) {
      return;
    }

    if (swiperEl.swiper) {
      swiperEl.swiper.update();
      console.log("Swiper updated");
    } else {
    new Swiper(swiperEl, {
      direction: "horizontal",
      slidesPerView: 1.1,
      centeredSlides: false,
      loop: false,
      spaceBetween: 5,
      threshold: 20,
      scrollbar: {
        el: "#swiper-related-products .swiper-scrollbar",
        hide: false,
        draggable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-related-products",
        prevEl: ".swiper-button-prev-related-products",
      },
      breakpoints: {
        992: {
          spaceBetween: 10,
        }
      }
    });
    }
  } 
}

export default RelatedProductsSwiper;